var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.775,
    height: 17.9,
    viewBox: "0 0 18.775 17.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1965",
    "data-name": "Trac\\xE9 1965",
    d: "M3.525,8.525c0-1.25.55-1.725,1.425-1.725s1.425.475,1.425,1.725v9.45c0,1.25-.55,1.725-1.425,1.725s-1.425-.475-1.425-1.725ZM.775,17.8c0,2.8,1.475,4.4,4.175,4.4s4.175-1.6,4.175-4.4V8.7c0-2.8-1.475-4.4-4.175-4.4S.775,5.9.775,8.7Zm9.475,1.025H15.5V22h2.75V18.825h1.3v-2.5h-1.3V4.5h-3l-5,11.825Zm2.525-2.5L15.45,9.85h.05v6.475Z",
    transform: "translate(-0.775 -4.3)",
    fill: "#c85f6b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon-04.7aa9c0251788f8b73f9def47061a1750.svg";
export { ForwardRef as ReactComponent };